module.exports = __webpack_public_path__ + "static/media/file-placeholder.66b9f662.png";